@if (navigationItems | async; as navigationItems) {
  @if (navigationItems.length > 2) {
    <!--
    Custom made, "Breadcrumb" component is mentioned in the UL Design System v3,
    but not implemented yet.
    -->
    <nav class="breadcrumb no-print" aria-label="Breadcrumb">
      @for (navigationItem of navigationItems; track navigationItem.url; let last = $last) {
        @if (last) {
          <span class="ul-label--disabled">
            {{ navigationItem.label }}
          </span>
        } @else {
          <a [routerLink]="['/' + navigationItem.url]">
            {{ navigationItem.label }}
          </a>
          <span class="breadcrumb-separator">/</span>
        }
      }
    </nav>
  }
}
